import { default as amplitude } from 'amplitude-js';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';

import { EVENTS } from 'constants/events';

const dev_key = '3a0587c3bbcac08167c5c2fd5b25b760';

export const initAmplitude = (user: { id: string }) => {
  amplitude
    .getInstance()
    .init(process.env.REACT_APP_AMPLITUDE_API_KEY || dev_key, user.id);
};

export const identifyUser = (user: $TSFixMe) => {
  const identify = new amplitude.Identify()
    .setOnce('first_name', user.first_name)
    .setOnce('last_name', user.last_name)
    .setOnce('email', user.email)
    .setOnce('company', user.company.id)
    .setOnce('location', user.settings.location_id);
  amplitude.getInstance().identify(identify);
};

// note: this is deprecated and new events only need to call logRudderstackEvent
// as Rudderstack API sends events to Amplitude as well
// we're keeping this here as older events are still using it
export const logEvent = (event: string, data: Record<string, any>) => {
  try {
    amplitude.getInstance().logEvent(event, omitBy(data, isNil));
  } catch (err) {
    console.log(err);
  }
};

export const logTransaction = (transaction: $TSFixMe, user: $TSFixMe) => {
  const product =
    transaction.type === 'store'
      ? transaction.store.product_code_name
      : transaction.reservation.event_title;

  const total = transaction.payment ? transaction.payment.total : 0;
  const revenue = new amplitude.Revenue()
    .setProductId(product)
    .setPrice(total)
    .setQuantity(1);

  amplitude.getInstance().logRevenueV2(revenue);

  if (transaction.type !== 'store') {
    return;
  }

  amplitude.getInstance().logEvent(EVENTS.CheckoutCompleted, {
    vendor_id: transaction.store.vendor_code_name,
    product_id: transaction.store.product_code_name,
  });

  if (transaction.payment && transaction.payment.points_used > 0) {
    const before = user.points_available;
    const after = before - transaction.payment.points_used;
    amplitude.getInstance().logEvent(EVENTS.UsedPoints, { before, after });
  }

  // set user attribute
  if (transaction.store && transaction.store.order_detail) {
    const { order_detail } = transaction.store;
    const user_attr = [
      'gender',
      'dob',
      'street',
      'street_ext',
      'city',
      'zip',
      'state',
    ];
    user_attr.forEach((field) => {
      if (order_detail[field]) {
        const identify = new amplitude.Identify().setOnce(
          field,
          order_detail[field]
        );
        amplitude.getInstance().identify(identify);
      }
    });
  }
};

export const logSubscriptionTransaction = (
  subscription: $TSFixMe,
  user: $TSFixMe
) => {
  const transaction = {
    type: 'store',
    store: {
      product_code_name: subscription.product_id,
      vendor_code_name: subscription.vendor_id,
      order_detail: subscription.membership_info,
    },
    payment: {
      total: subscription.total_amount,
      points_used: 0,
    },
  };

  logTransaction(transaction, user);
};
